"use client";
import Image from "next/image";
import React, { useState, useEffect } from "react";

const HeroSimpleImage = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!images || images.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3500);

    return () => clearInterval(interval);
  }, [images]);

  if (!images || images.length === 0) return null;

  return (
    <div className="relative w-full h-full overflow-hidden">
      {images.map((image, index) => (
        <Image
          key={image.id}
          src={`${image.filename}/m/1500x400`}
          alt={image.alt || "Hero image"}
          fill
          style={{ objectFit: "cover" }}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentIndex ? "opacity-100 z-10" : "opacity-0 z-0"
          }`}
          loading={index === 0 ? "eager" : "lazy"}
        />
      ))}
    </div>
  );
};

export default HeroSimpleImage;
